export const sendAnalyticsEvent = async (action, data = {}) => {
  const clientId = localStorage.getItem('filterPhoneNumber');
  window.parent.postMessage(
    {
      event: 'ga_chat_event',
      action,
      data: {
        ...data,
        clientId,
      },
    },
    '*'
  );

  // Post to segment
  try {
    await fetch('/api/segment', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        anonymousId: clientId,
        event: action,
        properties: {
          ...data,
          clientId,
        },
      }),
    });
  } catch (error) {
    // Silently handle analytics errors - don't let them break the app
    console.error('Analytics event failed:', error);
  }
};
